export default __webpack_public_path__ + "static/media/icon_cb_26.91c70c64.png";